// extracted by mini-css-extract-plugin
export default {"header":"custom-reports-details_header__kbS88","btnText":"custom-reports-details_btnText__i-Atl"};